export class CoverPhotoComponent {
    uploadErrorMessage: string =
        'Please upload photo smaller than 5 megabytes in size and use PNG, GIF or JPEG format.';

    onFile: any;
    onError: any;

    handleOnFile(node: any, file: any) {
        this.onFile && this.onFile({ file });
    }

    handleOnError(message: any) {
        this.onError && this.onError({ message });
    }
}

angular.module('tradersyard').component('tyCoverPhoto', {
    // language=HTML
    template: `
        <div class="cover">
            <div class="photo">
                <ty-upload-photo-button
                    ng-if="$ctrl.editable"
                    on-file="$ctrl.handleOnFile(node, file)"
                    on-error="$ctrl.onError(message)"
                    max-size="5242880"
                    class="upload-button"
                />
                <img class="picture cover-image" ng-src="{{$ctrl.photo|thumb:800:400}}" alt="">
            </div>


            <div class="cover_photo__content">
                <ng-transclude/>
            </div>
        </div>
    `,
    controller: CoverPhotoComponent,
    transclude: true,
    bindings: {
        photo: '<',
        editable: '<',
        uploadErrorMessage: '<',
        onFile: '&',
        onError: '&',
    },
});
